<mat-paginator
  [length]="allTrips.length"
  [pageSize]="pageSize"
  [hidePageSize]="true"
  (page)="onPaginate($event.pageIndex)"
  aria-label="Select page"
>
</mat-paginator>

<div *ngIf="isLoading" class="d-flex justify-content-center align-items-center" [ngStyle]="{height: '300px'}">
  <mat-spinner
    color="primary"
  ></mat-spinner>
</div>

<main>
  <p class="h1 text-center mt-5 text-black-50 prevent-select" *ngIf="!isLoading && !trips.length">
    {{lang === "en" ? "No Upcoming Trips to Show" : "لا يوجد رحلات قادمة للعرض"}}
  </p>

  <ng-container *ngFor="let trip of trips">
    <app-flight-card [trip]="trip"></app-flight-card>
    <app-hotel-card></app-hotel-card>
  </ng-container>
</main>

